// ====================================================================
// Helpers de roles — frontend
// ====================================================================
// Mantener sincronizado con backend/auth.py (ROLES_*)

export const ROLE_LABEL = {
  admin: "Administrador",
  gestor_senior: "Gestor Senior",
  gestor_siniestros: "Gestor de Siniestros",
  perito_interno: "Perito Interno",
  perito_externo: "Perito Externo",
  tramitador_telematico: "Tramitador Telemático",
};

export const ROLE_BADGE_CLASS = {
  admin: "bg-foreground text-white",
  gestor_senior: "bg-brand text-white",
  gestor_siniestros: "bg-status-success-bg text-status-success-fg border border-status-success-bd",
  perito_interno: "bg-surface text-foreground border border-border",
  perito_externo: "bg-surface text-muted border border-border italic",
  tramitador_telematico: "bg-status-info-bg text-status-info-fg border border-status-info-bd",
};

export const ROLES_VEN_TODO = new Set(["admin", "gestor_senior", "gestor_siniestros"]);
export const ROLES_PUEDEN_MINUTAR = new Set([
  "admin", "gestor_senior", "perito_interno", "perito_externo", "tramitador_telematico",
]);
export const ROLES_APRUEBAN_MINUTA = new Set(["admin", "gestor_senior"]);
export const ROLES_RAIZ_ERP = new Set(["admin"]);

export const ROLES_CREAN_INCIDENCIA = new Set(["admin", "gestor_senior", "gestor_siniestros"]);

// Roles que se comportan como perito a efectos operativos (recibir
// Avizores, ser asignable a un expediente como "Perito asignado", ver
// los siniestros que tienen su `code` en `extracted_data.perito_codigo`).
// IMPORTANTE: `admin` está aquí intencionalmente — un administrador
// también puede actuar como perito si su ficha de usuario tiene un
// `code` configurado.
export const ROLES_PERITO_LIKE = new Set([
  "perito_interno", "perito_externo", "tramitador_telematico", "admin",
]);

// Tramitador telemático: rol especializado en encargos Telemático de Santander.
// No accede a agenda ni a rutas (tramitación remota).
export const ROL_TRAMITADOR_TELEMATICO = "tramitador_telematico";

export const can = {
  rootAdmin: (user) => ROLES_RAIZ_ERP.has(user?.role),
  minute: (user) => ROLES_PUEDEN_MINUTAR.has(user?.role),
  approveMinute: (user) => ROLES_APRUEBAN_MINUTA.has(user?.role),
  seeAll: (user) => ROLES_VEN_TODO.has(user?.role),
  manageUsers: (user) => user?.role === "admin" || user?.role === "gestor_senior",
  manageInsurers: (user) => user?.role === "admin",
  manageBaremos: (user) => user?.role === "admin",
  openIncidencia: (user) => ROLES_CREAN_INCIDENCIA.has(user?.role),
  launchAvizor: (user) => ROLES_VEN_TODO.has(user?.role),
  useAgenda: (user) => user?.role !== ROL_TRAMITADOR_TELEMATICO,
  useRutas: (user) => user?.role !== ROL_TRAMITADOR_TELEMATICO,
  downloadAiTransparency: (user) =>
    user?.role === "admin" || user?.role === "gestor_senior",
};
